import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export const Spot = ({
  width,
  height
}) => /*#__PURE__*/React.createElement(S.Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "Spot",
  viewBox: "0 0 40 40",
  width: width,
  height: height
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "20.79 30.73 27.56 17.12 21.29 17.56 17.34 25.52 20.79 30.73"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M9,11H9a1.85,1.85,0,0,0-.8-.18,1.92,1.92,0,0,0-1.7,1.05l-2.3,4.63A1.92,1.92,0,0,0,4.11,18a1.88,1.88,0,0,0,1,1.09l10.5,5.5,4-8-.56-.3"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e60000",
  x: "31.82",
  y: "24.67",
  width: "3",
  height: "8.49",
  transform: "translate(-7.93 44.57) rotate(-61.74)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#101010;",
  d: "M14,19a3,3,0,0,0,3-3V2H11V16A3,3,0,0,0,14,19ZM13,4h2V16a1,1,0,0,1-2,0Z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "21.29 17.56 17.34 25.52 20.79 30.73 27.56 17.12 21.29 17.56"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#101010;",
  d: "M21.86,15.52,19,14v2.28l.55.29-4,8-10.5-5.5a1.88,1.88,0,0,1-1-1.09,1.92,1.92,0,0,1,.1-1.45l2.3-4.63a1.92,1.92,0,0,1,1.7-1.05A1.85,1.85,0,0,1,9,11H9V9a3.74,3.74,0,0,0-.81-.1A3.91,3.91,0,0,0,4.72,11l-2.3,4.63a3.9,3.9,0,0,0,1.76,5.22L16,27,21,34.73l9.87-19.85ZM20.79,30.73l-3.45-5.21,3.95-8,6.27-.44Z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e60000",
  x: "31.82",
  y: "24.67",
  width: "3",
  height: "8.49",
  transform: "translate(-7.93 44.57) rotate(-61.74)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e60000",
  x: "30.62",
  y: "19.18",
  width: "8.49",
  height: "3",
  transform: "translate(-3.36 7.19) rotate(-11.23)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e60000",
  x: "26.55",
  y: "29.98",
  width: "3",
  height: "8.49",
  transform: "translate(-12.1 15.63) rotate(-25.81)"
}));
Spot.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};
Spot.defaultProps = {
  width: '40px',
  height: '40px'
};